import { BrowserRouter as Router } from "react-router-dom";
import { Layout } from '../../layout/components/Layout';
import { AnalyticsProvider } from "../data/AnalyticsProvider";
import { RootStoreProvider } from '../data/root.store';
//import { StagewiseToolbar } from '@stagewise/toolbar-react';
//import { ReactPlugin } from '@stagewise-plugins/react';

function App() {

  return (
    <RootStoreProvider>
      <AnalyticsProvider>
        <Router>
          <Layout />
          {/* {process.env.NODE_ENV === 'development' && (
            <StagewiseToolbar
              config={{
                plugins: [ReactPlugin],
              }}
            />
          )} */}
        </Router>
      </AnalyticsProvider>
    </RootStoreProvider>
  );
}

export default App;